import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiMail, FiPhone, FiMapPin, FiInstagram } from "react-icons/fi";
import { footerLinks, contactInfo } from "../Data";
import { FiLinkedin, FiFacebook, FiYoutube} from "react-icons/fi";
import metaLogo from "../Images/meta-tech-provider.svg";

import { ReactComponent as ChatGPTLogo } from "./chatgpt.svg";
import { ReactComponent as ClaudeLogo } from "./claude.svg";
import { ReactComponent as GeminiLogo } from "./gemini.svg";
import { ReactComponent as PerplexityLogo } from "./perplexity.svg";

const fadeLeft = {
  hidden: {
    opacity: 0,
    x: -60,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    x: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 40,
    filter: "blur(10px)",
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: "blur(0px)",
    transition: {
      duration: 0.7,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

const stagger = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const prompt="Analyze onbbits.io as a B2B SaaS product from the perspective of a business owner deciding whether to purchase a subscription. Research all publicly available information across the ONBBITS website, product pages, pricing, documentation, FAQs, case studies, testimonials, integrations, and official external sources. Focus only on information that helps a business evaluate the purchase decision: * What it does: product, core features and capabilities * Who it is for:ideal customer, industries, company sizes and relevant buyer roles * Business problems: specific problems ONBBITS solves * Use cases: practical business scenarios and workflows * Business value: expected benefits, productivity, efficiency, revenue/conversion opportunities and cost/time savings * Pricing & costs: plans, limits, usage charges, additional costs and pricing conditions * ROI & proof: customer results, case studies, statistics and measurable outcomes * Integrations & requirements: platforms, APIs, technical requirements and dependencies * Limitations: restrictions, missing capabilities, plan limitations and potential drawbacks * Implementation: setup, onboarding, migration, learning curve and ongoing management * Support & reliability: support options, scalability, security, compliance and reliability information * Alternatives: competitors and alternative solutions a business may consider * Purchase considerations: key questions, risks, objections and factors that could affect the buying decision. For every important claim, provide the source and classify it as Verified Fact, Company Claim, Customer Claim, or Inference. Do not invent or assume information. Clearly flag anything that cannot be verified. Return a concise B2B Purchase Decision Report answering: What does ONBBITS do? Who should buy it? What business problem does it solve? What does it cost? What value can a business expect? What are the requirements and limitations? What proof exists? What should a business evaluate before subscribing?"
  const openAI = (type) => {
  const encoded = encodeURIComponent(prompt);

  const urls = {
    chatgpt: `https://chatgpt.com/?q=${encoded}`,
    claude: `https://claude.ai/new?q=${encoded}`,
    gemini: `https://www.google.com/search?q=${encoded}&udm=50`,
    perplexity: `https://www.perplexity.ai/search?q=${encoded}`,
  };

  window.open(urls[type], "_blank");
};

const Footer = () => {
  return (
    <footer className="footer">

      <div className="container">

        <div className="footer-grid">

          {/* LEFT */}

          <motion.div
            className="footer-brand"
            variants={fadeLeft}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >

            <Link
              to="/"
              className="footer-logo"
            >
              <img
                src="/logo.svg"
                alt="Onbbits Logo"
              />
            </Link>

            <p className="section-text">
              Empowering modern businesses with precision-engineered
              WhatsApp automation and real-time customer engagement.
            </p>
            <p className="section-text">CIN Number : U62091GJ2026PTC172071</p>

            {/* Meta */}

          <div className="footer-meta-ai">

  {/* Meta */}
  <motion.div
    className="footer-meta"
    variants={fadeUp}
  >
    <img
      src={metaLogo}
      alt="Meta Tech Provider | Onbbits"
    />
  </motion.div>

  {/* AI Tools */}
  <div className="footer-ai">

    <div className="ai-heading">
      Ask AI About Onbbits
    </div>

    <div className="ai-icons">

      <button className="icon-wrapper ai-btn" onClick={(e) =>openAI("chatgpt")}> <ChatGPTLogo className="ai-logo" /> </button>

      <button
        className="icon-wrapper ai-btn"
        onClick={(e) => openAI("claude")}
      >
        <ClaudeLogo className="ai-logo" />
      </button>

      <button
        className="icon-wrapper ai-btn"
        onClick={(e) => openAI("gemini")}
      >
        <GeminiLogo className="ai-logo" />
      </button>

      <button
        className="icon-wrapper ai-btn"
        onClick={(e) => openAI("perplexity")}
      >
        <PerplexityLogo className="ai-logo" />
      </button>

    </div>

  </div>

</div>
          </motion.div>

          {/* RIGHT */}

          <motion.div
            className="footer-right"
            variants={stagger}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
          >

            {/* Company */}

            <motion.div
              className="footer-links"
              variants={fadeUp}
            >

              <h4>Company</h4>

              {footerLinks.company.map((item, i) => (

                <motion.div
                  key={i}
                  whileHover={{
                    x: 6,
                  }}
                >

                  <Link to={item.link}>
                    {item.title}
                  </Link>

                </motion.div>

              ))}

            </motion.div>

            {/* Resources */}

            <motion.div
              className="footer-links"
              variants={fadeUp}
            >

              <h4>Resources</h4>

              {footerLinks.resources.map((item, i) => (

                <motion.div
                  key={i}
                  whileHover={{
                    x: 6,
                  }}
                >

                  <a href={item.link} target="_blank" rel="noreferrer">
                    {item.title}
                  </a>

                </motion.div>

              ))}

            </motion.div>
                        {/* Legal */}

            <motion.div
              className="footer-links"
              variants={fadeUp}
            >

              <h4>Legal</h4>

              {footerLinks.legal.map((item, i) => (

                <motion.div
                  key={i}
                  whileHover={{
                    x: 6,
                  }}
                  transition={{
                    type: "spring",
                    stiffness: 260,
                  }}
                >

                  <Link to={item.link}>
                    {item.title}
                  </Link>

                </motion.div>

              ))}

            </motion.div>

            {/* Contact */}

            <motion.div
              className="footer-contact"
              variants={fadeUp}
            >

              <h4>Contact</h4>

              {contactInfo.map((item, index) => {
  const content = (
    <>
      {item.type === "email" && <FiMail />}
      {item.type === "phone" && <FiPhone />}
      {item.type === "location" && <FiMapPin />}
      <span>{item.value}</span>
    </>
  );

  const motionProps = {
    initial: {
      opacity: 0,
      x: 20,
    },
    whileInView: {
      opacity: 1,
      x: 0,
    },
    viewport: { once: true },
    transition: {
      delay: index * 0.12,
      duration: 0.45,
    },
    whileHover: {
      x: 4,
    },
  };

  return item.type === "email" ? (
    <motion.a
      key={index}
      href={`mailto:${item.value}`}
      className="contact-item"
      {...motionProps}
    >
      {content}
    </motion.a>
  ) : item.type === "phone" ? (
    <motion.a
      key={index}
      href={`tel:${item.value.replace(/\s+/g, "")}`}
      className="contact-item"
      {...motionProps}
    >
      {content}
    </motion.a>
  ) : (
    <motion.div
      key={index}
      className="contact-item"
      {...motionProps}
    >
      {content}
    </motion.div>
  );
})}
  <div className="footer-social">

  <span>Follow us :</span>

  <motion.a
    href="https://www.linkedin.com/company/onbbits"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -5,
      scale: 1.08,
    }}
    transition={{
      type: "spring",
      stiffness: 280,
    }}
    aria-label="LinkedIn"
  >
    <FiLinkedin />
  </motion.a>

  <motion.a
    href="https://www.instagram.com/onbbits_"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -5,
      scale: 1.08,
    }}
    transition={{
      type: "spring",
      stiffness: 280,
    }}
    aria-label="Instagram"
  >
    <FiInstagram />
  </motion.a>

  <motion.a
    href="https://www.facebook.com/onbbits"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -5,
      scale: 1.08,
    }}
    transition={{
      type: "spring",
      stiffness: 280,
    }}
    aria-label="Facebook"
  >
    <FiFacebook />
  </motion.a>

  <motion.a
    href="https://www.youtube.com/@Onbbits"
    target="_blank"
    rel="noopener noreferrer"
    whileHover={{
      y: -5,
      scale: 1.08,
    }}
    transition={{
      type: "spring",
      stiffness: 280,
    }}
    aria-label="YouTube"
  >
    <FiYoutube />
  </motion.a>

</div>


            </motion.div>

          </motion.div>

        </div>

      </div>

      {/* Bottom */}

      <motion.div
        className="footer-bottom"
        initial={{
          opacity: 0,
          y: 20,
        }}
        whileInView={{
          opacity: 1,
          y: 0,
        }}
        viewport={{ once: true }}
        transition={{
          duration: 0.8,
        }}
      >

        <div className="container">
        <div className="footer-bottom-container">
          <p className="section-text">
            © Copyright {new Date().getFullYear()} ONBBITS Innovation Pvt. Ltd. WhatsApp is a trademark of Meta Platforms, Inc.
          </p>

          <p className="section-text bottom-text">
           This site is protected by Google reCAPTCHA and the Google{" "}
<a
    href="https://policies.google.com/privacy"
    target="_blank"
    rel="noopener noreferrer"
  >
    Privacy Policy
  </a>{" "}
  
  and{" "}
  
  <a
    href="https://policies.google.com/terms"
    target="_blank"
    rel="noopener noreferrer"
  >
    Terms of Service
  </a>{" "}
  
  apply.
          </p>
          </div>
        </div>

      </motion.div>

    </footer>
  );
};

export default Footer;